<template>
  <div class="md-card agendaItem">
    <div
      class="text-primary regular"
      style="font-size:18px;margin-left:5px;margin-bottom:6px;margin-top:10px"
    >{{item.description.topic}}</div>

    <div v-if="showThematicPath" class="regular" style="font-size:14px;">
      <img v-if="panelIcon" :src="panelIcon" style="width:22px; margin-right:5px;margin-left:5px" />
      {{item.description.thematicPath}}
    </div>

    <div
      style="font-size:14px;margin-top:20px"
      class="text-gray regular"
      v-if="agendaSettings.showTime"
    >
      <md-icon>schedule</md-icon>
      {{item.startDate | moment("HH:mm")}} - {{item.endDate | moment("HH:mm")}}
    </div>

    <div class="md-layout md-layout-item md-size-100">
      <div class="ml-auto">
        <md-button
          @click.prevent="$emit('showDetails')"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:5px 10px"
        >{{$t('Show more')}}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";

export default {
  props: [
    "item",
    "showDate",
    "showThematicPath",
    "showDetailsLink",
    "showDescription",
    "bigHeader"
  ],
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      agendaSettings: "user/agendaSettings"
    }),

    localisation() {
      let localisation = this.item.description.building;

      if (localisation && this.item.description.room) {
        localisation += ", ";
      }

      localisation += this.item.description.room;

      return localisation;
    },
    // panelColor() {
    //   return this.$options.filters["panel-color"](
    //     this.item.description.thematicPath
    //   );
    // },
    panelIcon() {
      return this.$options.filters["panel-icon"](
        this.item.description.thematicPath
      );
    }
  },
  methods: {
    gotoDetails(id) {
      this.$router.push({ name: "panelDetails", query: { id: id } });
    },
    async onLike(value) {
      let loader = this.$loading.show();
      let action = value ? "add" : "remove";
      let success = true;
      try {
        this.item.isLiked = (
          await axios.post(`public/myprofile/agenda/favourites/${action}`, {
            id: this.item.id
          })
        ).data;
      } catch {
        success = false;
      } finally {
        if (success) {
          let text = value
            ? this.$t("Added to My Agenda")
            : this.$t("Removed from My agenda");
          this.$swal({
            icon: "success",
            text: text
          });
        }

        loader.hide();
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped >
div.statuses {
  margin: 5px 0px 10px 0px;
}

.statuses .md-button.md-just-icon {
  height: 22px;
  min-width: 0px;
  width: 24px;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
  position: relative;
}

.statuses .md-button .md-ripple {
  padding: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;

  .md-icon {
    padding: 0px !important;
  }
}

.md-card {
  padding: 10px;
  margin: 20px 0px 20px 0px;
  background: #ffffff;
  box-shadow: 0px 0px 30px #0000001a;
  border-radius: 15px;
  opacity: 1;
}

.md-card .md-card-content {
  padding: 0px;
  line-height: inherit;
}

.md-collapse-content p {
  margin-bottom: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>